function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.99954V2.20954C12 1.75954 11.46 1.53954 11.15 1.85954L8.35 4.64954C8.15 4.84954 8.15 5.15954 8.35 5.35954L11.14 8.14954C11.46 8.45954 12 8.23954 12 7.78954V5.99954C15.31 5.99954 18 8.68954 18 11.9995C18 12.7895 17.85 13.5595 17.56 14.2495C17.41 14.6095 17.52 15.0195 17.79 15.2895C18.3 15.7995 19.16 15.6195 19.43 14.9495C19.8 14.0395 20 13.0395 20 11.9995C20 7.57954 16.42 3.99954 12 3.99954ZM12 17.9995C8.69 17.9995 6 15.3095 6 11.9995C6 11.2095 6.15 10.4395 6.44 9.74954C6.59 9.38954 6.48 8.97954 6.21 8.70954C5.7 8.19954 4.84 8.37954 4.57 9.04954C4.2 9.95954 4 10.9595 4 11.9995C4 16.4195 7.58 19.9995 12 19.9995V21.7895C12 22.2395 12.54 22.4595 12.85 22.1395L15.64 19.3495C15.84 19.1495 15.84 18.8395 15.64 18.6395L12.85 15.8495C12.54 15.5395 12 15.7595 12 16.2095V17.9995Z",
    fill: "#667085",
    style: {
      fill: "#667085",
      fill: "color(display-p3 0.4009 0.4408 0.5207)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/sync-icon.d68299935b40d6602d9f13fb6919e7ee.svg";
export { ForwardRef as ReactComponent };